exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!select2/dist/css/select2.css"), "");

// Module
exports.push([module.id, ".select2-container--default .select2-selection--multiple{border:1px solid #D2D6DE;border-radius:0px}.select2-container--default.select2-container--focus .select2-selection--multiple{border:1px solid #D2D6DE}.select2-container--default .select2-selection--multiple .select2-selection__choice{background-color:#0376b5}.select2-container--default .select2-selection--multiple .select2-selection__choice__remove{color:white}.select2{width:100% !important}\n", ""]);

